import axios from 'axios';
import { config } from '../config/env';

let inFlight = null;

/**
 * Re-mint the short-lived access JWT from the still-valid session, by POSTing to
 * Common Auth's /api/v1/auth/refresh (which re-issues the `access` cookie).
 *
 * The access JWT expires every ~10 min while the session lives far longer; without
 * this the next API call 401s and bounces the user to login. On a 401 carrying
 * `X-Error-Code: JWT_EXPIRED`, call this and retry the original request instead of
 * redirecting. Deduped via a shared in-flight promise so a burst of concurrent
 * 401s triggers exactly one refresh.
 *
 * @returns {Promise<boolean>} true if the token was refreshed.
 */
export function refreshAccessToken() {
  if (!inFlight) {
    inFlight = axios
      .post(`${config.COMMON_AUTH_URL}/api/v1/auth/refresh`, {}, { withCredentials: true })
      .then(() => true)
      .catch(() => false)
      .finally(() => { inFlight = null; });
  }
  return inFlight;
}
